import { Grid } from '@epilot/journey-elements'

import { AttributeItem } from '../EntityLookupControl/components/AttributeItem'

import type { AttributeReadOnlyProps } from './types'

export function AttributeReadOnly({ options, value }: AttributeReadOnlyProps) {
  const { attributeName, attributeLabel, attributeType } = options
  const defaultLabel = attributeLabel || attributeName || ''

  switch (attributeType) {
    case 'select': {
      // in the case the attribute is of type select, we need to get the label of the selected option from the additionalOptions
      const { options: selectOptions, optionsLabels: selectLabels } =
        options.additionalOptions?.uischema?.options || {}

      const optionIndex = selectOptions?.indexOf(value as string)

      const tValue =
        optionIndex > -1 && Array.isArray(selectLabels)
          ? selectLabels[optionIndex]
          : value

      return (
        <Grid container>
          <AttributeItem label={defaultLabel} value={tValue} />
        </Grid>
      )
    }
    default: {
      return (
        <Grid container>
          <AttributeItem label={defaultLabel} value={value as string} />
        </Grid>
      )
    }
  }
}
